<template>
  <vx-card class="mt-3">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <img height="40" width="40" class="round mr-3 img-fluid"
             :src="user.image||require('@/assets/images/avatar.png')">
        <div class="mr-2">
          <div>
            <b>
              <router-link v-if="user.profilePath" :to="user.profilePath">{{user.name}}</router-link>
              <span v-else> {{user.name}}</span>
            </b>
          </div>
          <div title="زمان ارسال" class="ltr">{{persianTime(localMessage.sentTime)}}</div>
        </div>
      </div>
      <div>
        <div class="text-center text-success" v-if="localMessage.readTime">
          <feather-icon icon="EyeIcon"></feather-icon>
          <div>خوانده شده</div>
          <div class="ltr">{{persianTime(localMessage.readTime)}}</div>
        </div>
        <div v-else>
          <div class="text-danger text-center mr-5" v-if="context === 'sent_messages'">
            <feather-icon icon="EyeOffIcon"></feather-icon>
            <div>خوانده نشده</div>
          </div>
          <vs-button v-else @click="readMessage(localMessage.id)" type="border">خواندم</vs-button>
        </div>
      </div>
    </div>
    <div class="mt-2" :class="{'text-bold' : !localMessage.readTime}">
      {{localMessage.content}}
    </div>
  </vx-card>
</template>

<script>
  import moment from "moment-jalaali";

  export default {
    props: {
      message: [Object],
      context: [String]
    },
    mounted() {

      this.localMessage = Object.assign({}, this.message)
    },
    data() {
      return {
        localMessage: ''
      }
    },
    computed: {
      users() {
        return this.$store.state.users
      },
      user() {
        let user
        if (this.context === 'sent_messages') {
          user = this.message.toUser
        } else {
          user = this.message.fromUser
        }
        user.name = user.firstName + ' ' + user.lastName
        user.image = user.imagePath.includes("/photo/null") ? null : user.imagePath

        if (user.id > 0 && this.$store.state.AppActiveUser.role === 'MODERATOR') {
          let role = user.role || 'STUDENT'
          user.profilePath = role.toLowerCase() + 's' + '/edit/' + user.id
        } else {
          user.profilePath = null
        }
        return user
      }
    },
    methods: {
      readMessage(id) {
        this.$http.post('message/read', {
          requester: this.$store.getters.userCredentials,
          request: {
            "messageIds": [id],
            "read": 1
          }
        }).then(res => {
          if (res.data.result) {
            this.localMessage.readTime = Date.now()
            this.$store.commit('MESSAGE_READ', this.localMessage.id)
          }
        })
      },
      persianTime(time) {
        return moment(time).format('jYYYY/jM/jD HH:mm')
      },

    }
  }
</script>


<style scoped>
  .text-bold {
    font-weight: bold;
    color: black !important;
  }

  .ltr {
    direction: rtl;
    display: inline-block;
  }
</style>
